import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { Icon } from '@zapier/design-system';
import { clsx } from 'clsx';
import React from 'react';
import { Button } from 'react-aria-components';

const iconButton = "_icon-button_1a01z_1";
const styles = {
	iconButton: iconButton
};

const IconButton = (_a) => {
  var { className, isDisabled = false, name, size = "medium", style, variant = "primary" } = _a, props = __rest(_a, ["className", "isDisabled", "name", "size", "style", "variant"]);
  return React.createElement(
    Button,
    Object.assign({}, props, { className: clsx(className, styles.iconButton), "data-variant": variant, "data-size": size, "data-zds": true, isDisabled, style }),
    React.createElement(Icon, { name, size: 24 })
  );
};

export { IconButton };
//# sourceMappingURL=IconButton.es.js.map
